module.exports = __webpack_public_path__ + "static/img/wecompay.8e2933f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/wecompay.png
// module id = Rxd/
// module chunks = 0